import type { NextPage } from "next";
import Template from "@app/Template/Template";
import ContractGeneratorForm from "@features/contract-generator/contract-generator-form";
import { configApi } from "@shared/lib/configApi";
import { RouterConfig } from "@shared/lib/routerConfig";
import { CustomHead, DEFAULT_OG_IMAGE } from "@shared/ui/CustomHead";

const ContractGenerator: NextPage = () => {
    return (
        <Template bgColor="blue">
            <CustomHead
                title={"Скачать договор купли-продажи автомобиля, мотоцикла | Бланк"}
                description={
                    "Скачать готовый образец договора купли-продажи автомобиля, мотоцикла в PDF. Образец 2024 года на likvi.com"
                }
                robots={"index,follow"}
                canonical={`${configApi.API_PUBLIC_DOMAIN}${RouterConfig.GENERATOR_DKP}`}
                openGraph={{
                    title: "Скачать договор купли-продажи автомобиля, мотоцикла | Бланк",
                    description:
                        "Скачать готовый образец договора купли-продажи автомобиля, мотоцикла в PDF. Образец 2024 года на likvi.com",
                    url: `${configApi.API_PUBLIC_DOMAIN}${RouterConfig.GENERATOR_DKP}`,
                    type: "website",
                    image: {
                        url: DEFAULT_OG_IMAGE,
                        width: 1200,
                        height: 630,
                        alt: "Скачать договор купли-продажи автомобиля, мотоцикла | Бланк"
                    }
                }}
            />
            <ContractGeneratorForm />
        </Template>
    );
};

export default ContractGenerator;